import { useTranslation } from 'next-i18next';
import { shallowEqual } from 'react-redux';
import { UiComponent } from '../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from './PageBuilderSettingsTable';

interface StylingSettingsTemplateInterface<T extends UiComponent> {
  onChange: (c: T) => void;
  component: T;
}

function StylingSettingsTemplate<T extends UiComponent>({ component, onChange }: StylingSettingsTemplateInterface<T>) {
  const fields = useSelector(({ common }) => common.registrationFields.filter((f) => f.valueOptions.length > 0 && !f.canMultiSelect), shallowEqual);
  const event = useSelector(({ common }) => common.event);

  const { t } = useTranslation();

  const baseStylingSettings: PageBuilderSettingsSection[] = [
    {
      name: 'Basis',
      settings: [
        {
          label: t('pagebuilder:background'),
          path: 'styling.backgroundColor',
          type: 'color',
        },
        {
          label: t('pagebuilder:fontcolor'),
          path: 'styling.textColor',
          type: 'color',
        },
        {
          label: t('pagebuilder:opacity'),
          path: 'styling.backgroundOpacity',
          type: 'slider',
          sliderProps: {
            scale: (value) => value * 100,
            valueLabelDisplay: 'auto',
            'aria-labelledby': 'continuous-slider',
            step: 0.1,
            min: 0,
            max: 1,
          },
        },
        {
          label: `${t('pagebuilder:max-width')} (px)`,
          path: 'styling.customMaxWidth',
          type: 'number',
          defaultValue: component.styling.customMaxWidth || 1333,
          textFieldProps: {
            InputProps: { type: 'number', inputProps: { min: 0, max: 9999 } },
            noarrows: false,
          },
          visible: !component.isFullWidth,
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={baseStylingSettings} onChange={onChange} component={component} showTitleAndDescription={false} />;
}
export default StylingSettingsTemplate;
